import MainLayout from '../layout/MainLayout';
import { SectionTabs, SECTIONS } from './SectionTabs';
import { PageSkeleton } from './PageSkeleton';

/**
 * PageShell — Universele pagina-container
 *
 * Dwingt consistente layout af voor ALLE sectiepagina's:
 * - Altijd MainLayout
 * - Altijd SectionTabs (indien section meegegeven)
 * - Altijd min-h-screen bg-white
 * - Children krijgen de rest van de ruimte
 *
 * @param {string}  section  - 'risicos' | 'verbeteren' | 'beoordelen' | 'organisatie' | null
 * @param {boolean} loading  - Toont skeleton loader
 * @param {string}  testId
 * @param {node}    children - PageToolbar + content
 */
export const PageShell = ({ section, children, testId, loading }) => {
  const sectionConfig = section ? SECTIONS[section] : null;

  if (loading) {
    return (
      <MainLayout>
        <div className="min-h-screen bg-white" data-testid={testId}>
          {sectionConfig && <SectionTabs tabs={sectionConfig.tabs} />}
          <PageSkeleton />
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="min-h-screen bg-white" data-testid={testId}>
        {sectionConfig && <SectionTabs tabs={sectionConfig.tabs} />}
        {children}
      </div>
    </MainLayout>
  );
};
